module.exports = __webpack_public_path__ + "img/login.67905c69.png";